import { getApp, getApps, initializeApp } from 'firebase/app';
import type { FirebaseApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import type { Auth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import type { Firestore } from 'firebase/firestore';
import { STAKKO_FIREBASE_CONFIG } from './config';

export interface StakkoFirebase {
  app: FirebaseApp;
  auth: Auth;
  db: Firestore;
}

export interface StakkoFirebaseOverrides {
  app?: FirebaseApp | null;
  auth?: Auth | null;
  db?: Firestore | null;
}

/**
 * Vrací Firebase instance, které aplikace už používá.
 *
 * Záměrně **neinicializuje** novou appku, pokud už nějaká existuje – jinak by
 * v aplikacích, které volají `initializeApp()` samy, vznikl `duplicate-app`.
 * Pokud aplikace žádnou instanci nemá, vytvoří se default app z konfigurace.
 */
export function resolveStakkoFirebase(overrides?: StakkoFirebaseOverrides): StakkoFirebase {
  const app =
    overrides?.app ??
    (getApps().length > 0 ? getApp() : initializeApp(STAKKO_FIREBASE_CONFIG));

  return {
    app,
    auth: overrides?.auth ?? getAuth(app),
    db: overrides?.db ?? getFirestore(app),
  };
}
